<svg
	[style.width.px]='size'
	[style.height.px]='size'
>
	<use attr.xlink:href="/assets/sprite.svg#{{icon}}"></use>
</svg>
